import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { getSentryDsn, getTelemetryEnvironment } from "./lib/runtimeConfig";
import { installChunkReloadListener } from "./components/ChunkErrorBoundary";
import "./styles.css";

// Stale-deploy chunk failures (Vite `vite:preloadError`) reload the page once;
// installed before the first render so the very first lazy route is covered.
// The lazy-import rejection path is <ChunkErrorBoundary> in App.jsx.
installChunkReloadListener();

// #1956: runtime config (window.__XRING_CONFIG via /env.js) wins over the
// build-time VITE_* inline, so one image serves every environment.
const dsn = getSentryDsn();

if (dsn) {
  Sentry.init({
    dsn,
    // Same-origin tunnel: the browser POSTs envelopes to this relative path,
    // which the edge proxies to the error backend. Relative so one build works
    // for every environment (auto-targets whatever origin served the app).
    tunnel: "/_sentry",
    environment: getTelemetryEnvironment(),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Respect Do Not Track
    beforeSend(event) {
      if (
        navigator.doNotTrack === "1" ||
        window.doNotTrack === "1" ||
        navigator.msDoNotTrack === "1"
      ) {
        return null;
      }
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
